import {createActions, handleActions} from 'redux-actions';

export const actions = createActions({}, 'ERROR_SET', 'ERROR_CLEAR');

/**
 * Manage dirty state state.
 *
 * Keep track of keys that specify which items are dirty (assuming more than one thing can be dirty at a time).
 */
export const reducer = handleActions({
	[actions.errorSet]: (state, {payload: {title, message}}) => ({
		title,
		message
	}),
	[actions.errorClear]: () => null
}, null);


// WEBPACK FOOTER //
// ./src/error.state.js